import { _ } from '@ngx-translate/core';
import { addDays, addMonths, addWeeks, format, subDays, subMonths, subWeeks } from 'date-fns';

import type { MenuNode } from './command-palette.model';

type PeriodView = 'day' | 'week' | 'month';

const periodItem = (
  slug: string,
  titleKey: string,
  basePath: unknown[],
  view: PeriodView,
  offset: (today: Date) => Date,
): MenuNode => ({
  slug,
  titleKey,
  onSelect: ({ router }) => {
    const date = format(offset(new Date()), 'yyyy-MM-dd');
    router.navigate([...basePath, view, { date }]);
  },
});

/** The nine relative-period leaf items (today, this week, next month, …) under a view. */
export const periodsFor = (slugPrefix: string, basePath: unknown[]): MenuNode[] => [
  periodItem(`${slugPrefix}.today`, _('Today'), basePath, 'day', (today) => today),
  periodItem(`${slugPrefix}.yesterday`, _('Yesterday'), basePath, 'day', (today) => subDays(today, 1)),
  periodItem(`${slugPrefix}.tomorrow`, _('Tomorrow'), basePath, 'day', (today) => addDays(today, 1)),
  periodItem(`${slugPrefix}.this-week`, _('This week'), basePath, 'week', (today) => today),
  periodItem(`${slugPrefix}.last-week`, _('Last week'), basePath, 'week', (today) => subWeeks(today, 1)),
  periodItem(`${slugPrefix}.next-week`, _('Next week'), basePath, 'week', (today) => addWeeks(today, 1)),
  periodItem(`${slugPrefix}.this-month`, _('This month'), basePath, 'month', (today) => today),
  periodItem(`${slugPrefix}.last-month`, _('Last month'), basePath, 'month', (today) => subMonths(today, 1)),
  periodItem(`${slugPrefix}.next-month`, _('Next month'), basePath, 'month', (today) => addMonths(today, 1)),
];

/** Employee-view and team-view groups, each expanding into the relative periods. */
export const viewsFor = (slugPrefix: string, routePrefix: string): MenuNode[] => [
  {
    slug: `${slugPrefix}.employee-view`,
    titleKey: _('Employee view'),
    children: periodsFor(`${slugPrefix}.employee-view`, [routePrefix, 'employee']),
  },
  {
    slug: `${slugPrefix}.team-view`,
    titleKey: _('Team view'),
    children: periodsFor(`${slugPrefix}.team-view`, [routePrefix, 'team']),
  },
];
